// JavaScript Document
//components/configuration/standard/daysettings/Simulator.js
import React from 'react';
//theme
import { makeStyles } from '@material-ui/core/styles';
//material-ui core components
import {
    //Layout
    Typography, Box, Grid, Paper, Tooltip, 
    //Input
    TextField, Slider} from '@material-ui/core';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
  } from '@material-ui/pickers';

//icons
import { PortableWifiOff as RadarOff, WifiOff as ModemOff, FlashOff as DisplayOff} from '@material-ui/icons';
//date handling
import moment from 'moment';
import MomentUtils from '@date-io/moment';
//Custom component imports
import dsutils from './Utils';
import DisplaySimulator from './DisplaySimulator';
import DisplayMode from './DisplayMode';
import displayVariant from '../displayVariant';
//import { CallMissedSharp } from '@material-ui/icons';
const utils = dsutils();
//import withWidth from "@material-ui/core/withWidth";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
    speedInput : {
        width : 150,
        textAlign : 'right'
    },
    timeInput : {
        width : 150
    },
    timecontainer : {
        width : 180,
        textAlign : 'center'
    },
    speedcontainer : {
        width : '100%',
        textAlign: 'center',
        marginRight : theme.spacing(1),
        marginLeft : theme.spacing(1)
    },
    speedinnter : {
        width : '100%'
    },
    modecontainer : {
		textAlign: 'center',
		padding: 0,
		margin: 0,
		display: 'inline-block',
		maxWidth: 330,
		minWidth: 165,
	},
    tfcontainer : {
        minWidth: 150,
       // maxWidth: 250,
        margin: 1,
        textAlign: 'center'
    }
}));


export default function Simulator(props) {
	const classes = useStyles();
	//inherited variables
  	const {sign, config, date} = props;
    //time to simulate
    const [simtime, setSimtime] = React.useState(moment().format('HH:mm'));
    //vehicle speed to simulate
    const [speed, setSpeed] = React.useState(0);
    //display variant info
    const dv = displayVariant(sign);

    //check if curdate is in master shutdown
    const isMasterShutdown = (checkDate) => {
        if(!config.master_shutdown) return false;
        if(config.master_shutdown.length === 0) return false;
        return config.master_shutdown.findIndex(ms => ms.dateOff >= checkDate && ms.dateOn < checkDate) !== -1;
    }
    
    //get daysetting id of the provided date
    const getDateSetting = (checkDate) => {
        if(isMasterShutdown(checkDate)) return false;
        let sevent = config.special_events.find(e => e.date === checkDate);
        if(sevent) return sevent.day_settings;
        return config[moment(checkDate).format('dddd').toLowerCase()];
    }

    //todays daysetting
    const curdateSetting = getDateSetting(date);

    const getSetting = (settings) => {
        if(!settings.intervals) return settings.default;
        if(settings.intervals.length === 0) return settings.default;
        let interval = settings.intervals.find((i => simtime >= i.on && simtime < i.off));
        if(interval) return interval.value;
        return settings.default;
    }

    const getPower = (power) => {
        if(!power) return true;
        if(power.length === 0) return true;
        return power.reduce((c, v) => {
            if(simtime >= v[0] && simtime < v[1]) return true;
            return c;
        }, false);
    }

    const getCurSettings = () => {
        //speed, threshold, maxspeed, op
        return Object.assign({}, utils.model.settingList.reduce((settings, setting) => {
            settings[setting] = getSetting(config.daysettings[curdateSetting][setting]);
            return settings;
        }, {}), 
            utils.model.powers.reduce((cp, power) => {
                cp[power.type] = getPower(config.daysettings[curdateSetting][power.type]);
                return cp;
        }, {}));
    }

    

    const currentSettings = getCurSettings();
    
    
    //when the time picker is updated
    const handleTimeChange = (val) => {
        //console.log(val);
        setSimtime(val.format('HH:mm'));
    }


    const speedval = (value) => {
        if(!value) return 0;
        return value;
    }
    const timeval = (v) => {
        //return simtime;
       return [Math.floor(v / 60), v % 60].map(o => o.toString().padStart(2, '0')).join(':');
    }
    const valtime = (t) => {
        let [hour, min] = t.split(':', 2).map(v => parseInt(v));
        return hour * 60 + min;
    }
    const timeMarks = utils.control.setting.flatIntervalTimes(config.daysettings[curdateSetting]).filter(n => n).map(v => {return { value: valtime(v)}});
    const speedMarks = [{value: currentSettings.threshold}, {value: currentSettings.maxspeed}, {value: config.maxTwoDisplaySpeed || 99}];
    const timeUI = (<Paper className={classes.tfcontainer}>
        <Typography variant='caption'>Time</Typography>
        <KeyboardTimePicker
                id="time-picker"
                value={moment([date, simtime].join(' '))}
                onChange={handleTimeChange}
                KeyboardButtonProps={{
                    'aria-label': 'change time',
                }}
                fullWidth
                inputProps={{style : {textAlign:'center'}}}
        />
        <Slider
                value={valtime(simtime)}
                onChange={(e, v) => setSimtime(timeval(v))}
                aria-labelledby="time" 
                min={0}
                max={1439}
                marks={timeMarks}
                valueLabelDisplay='auto'
                getAriaValueText={timeval}
                valueLabelFormat={timeval}
        />
    </Paper>);
    const speedUI = (<Paper className={classes.tfcontainer}>
        <Typography variant='caption'>Vehicle Speed</Typography>
        <TextField 
                id='vspeed_input'
                name='speed'
                value={speed}
                onChange={(e) => setSpeed(e.target.value)}
                type='number'
                inputProps={{min: 0, max : 100, step: 1, style: {textAlign:'center'}}}
                fullWidth
                
        />
       
        <Slider 
                value={speed} 
                onChange={(e, v) => setSpeed(v)} 
                aria-labelledby="speed" 
                valueLabelDisplay='auto'
                getAriaValueText={speedval}
                marks={speedMarks}
        />
     </Paper>);
     
     const modeUI = (
        <div>
            <DisplayMode config={config} settings={currentSettings} sign={sign} />
            <Box display='flex' alignItems='center' justifyContent='space-around'>
            {currentSettings.power === false ? <Tooltip arrow title='Display off'><DisplayOff color='error' /></Tooltip> : ''}
            {currentSettings.radarpower === false ? <Tooltip arrow title='Radar off'><RadarOff color='error' /></Tooltip> : ''}
            {currentSettings.auxpower === false ? <Tooltip arrow title='Modem off'><ModemOff color='error' /></Tooltip>: ''}
            </Box>
        </div>
    );
     const simUI = (
        <DisplaySimulator
            config={config}
            sign={sign}
            settings={currentSettings}
            speed={speed}
            scale={4}
        />
     );

 
    //console.log(timeMarks);
    //render ui for no digit signs
    if(dv.digits === 0) return (
    	<MuiPickersUtilsProvider utils={MomentUtils}>
            <Grid container alignItems='center'>
                <Grid item xs={12} md={6}>
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            {timeUI}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {speedUI}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box display='flex' alignItems='center' justifyContent='space-around'>
                       {modeUI}{simUI}
                    </Box>
                </Grid>
            </Grid>
        </MuiPickersUtilsProvider>
  	);
    //render ui for the rest
    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <Grid container alignItems='center'>
                <Grid item xs={12} md={6}>
                    {timeUI}{speedUI}
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box display='flex' alignItems='center' justifyContent='space-around'>
                       {modeUI}{simUI}
                    </Box>
                </Grid>
            </Grid>
        </MuiPickersUtilsProvider>

    );
}
